import { Attachment_Thumbnail_Type_Enum } from '@skychute/schema';

export interface AttachmentThumbnailInterface {
  attachment_thumbnail_type?: Attachment_Thumbnail_Type_Enum;
  thumbnail_url?: string;
}
